var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrapper",on:{"scroll":_vm.checkH}},[_c('HomeBanner'),_c('HomeIntro'),_c('GallerySection'),_c('TestimonySection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }